import { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

import { MAX_TIP_PERCENTAGE, resolveTipPercentages } from 'lib/constants/transaction/tips';

import Input from 'components/shared/Input/Input';
import Switch from 'components/shared/Switch/Switch';

const PRESET_LABELS = ['Option 1', 'Option 2', 'Option 3'];

const TipSettings = () => {
  const { setFieldValue, values } = useFormikContext();
  const percentages = resolveTipPercentages(values?.displaySettings);
  const [inputs, setInputs] = useState(() => percentages.map(String));

  useEffect(() => {
    setInputs(percentages.map(String));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentages.join(',')]);

  const updateDisplaySettings = (patch) =>
    setFieldValue('displaySettings', { ...values?.displaySettings, ...patch });

  const handleAllowTipsChange = (checked) => {
    updateDisplaySettings({ allow_tips: checked, tip_percentages: percentages });
    setFieldValue('allowTips', checked);
  };

  const handleInputChange = (index, next) => {
    if (!/^\d*\.?\d{0,2}$/.test(next)) return;
    setInputs((current) => current.map((value, i) => (i === index ? next : value)));
  };

  const handleInputBlur = (index) => {
    const parsed = parseFloat(inputs[index]);
    const isValid = Number.isFinite(parsed) && parsed > 0 && parsed <= MAX_TIP_PERCENTAGE;
    const nextPercentages = percentages.map((value, i) =>
      i === index && isValid ? Math.round(parsed * 100) / 100 : value
    );

    setInputs(nextPercentages.map(String));
    updateDisplaySettings({ tip_percentages: nextPercentages });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <p className="text-base font-500 leading-6 text-neutral-900">Gratuity</p>
        <p className="text-sm leading-[22px] text-neutral-700">
          Let patients add a tip when they pay. The options below appear in the Add gratuity section
          of every payment.
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Switch
          checked={values?.allowTips}
          onChange={handleAllowTipsChange}
          id="allow-tips-switch"
        />
        <label htmlFor="allow-tips-switch" className="text-sm font-400 text-neutral-900">
          Offer gratuity on payments
        </label>
      </div>

      {values?.allowTips && (
        <div className="flex flex-col gap-3">
          <p className="text-base font-500 leading-6 text-neutral-900">Suggested tip percentages</p>
          <div className="flex flex-col gap-4">
            {inputs.map((value, index) => {
              const id = `tip-percentage-${index}`;
              return (
                <div key={id} className="flex items-center gap-4">
                  <label htmlFor={id} className="w-14 text-sm text-neutral-700">
                    {PRESET_LABELS[index]}
                  </label>
                  <Input
                    id={id}
                    value={value}
                    onChange={(event) => handleInputChange(index, event.target.value)}
                    onBlur={() => handleInputBlur(index)}
                    type="text"
                    inputMode="decimal"
                    rightText="%"
                    className="w-[120px]"
                    data-qa={id}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TipSettings;
